import { useLocalStorage } from 'hooks/use-local-storage';
import PropTypes from 'prop-types';
import { useCallback, useMemo } from 'react';
import { SettingsContext } from './settings-context';
// hooks

// ----------------------------------------------------------------------

export function SettingsProvider({ children, defaultSettings }) {
  const [settings, setSettings] = useLocalStorage('settings', defaultSettings);

  const onUpdate = useCallback(
    (name, value) => {
      setSettings((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [setSettings]
  );

  // Reset
  const onReset = useCallback(() => {
    setSettings(defaultSettings);
  }, [defaultSettings, setSettings]);

  const isAnalyticsDisabled = useCallback(() => {
    return settings?.cookiesStatus === "rejected";
  }, [settings]);

  const memoizedValue = useMemo(
    () => ({
      ...settings,
      onUpdate,
      onReset,
      isAnalyticsDisabled, // 👈 Expose here
    }),
    [onReset, onUpdate, settings, isAnalyticsDisabled]
  );

  return <SettingsContext.Provider value={memoizedValue}>{children}</SettingsContext.Provider>;
}

SettingsProvider.propTypes = {
  children: PropTypes.node,
  defaultSettings: PropTypes.object,
};
